export const SAFEWALK_ACTIVATED_TEXT = 'SAFEWALK_ACTIVATED_TEXT'
export const SAFEWALK_ALARM_ACTIVE_BODY_TEXT = 'SAFEWALK_ALARM_ACTIVE_BODY_TEXT'
export const SAFEWALK_ALARM_CANCELLED_BODY_TEXT = 'SAFEWALK_ALARM_CANCELLED_BODY_TEXT'
export const SAFEWALK_ALARM_ENDED_BODY_TEXT = 'SAFEWALK_ENDED_BODY_TEXT'
export const SAFEWALK_ALARM_WARNING_BODY_TEXT = 'SAFEWALK_ALARM_WARNING_BODY_TEXT'
export const SAFEWALK_BUTTON_ALARM_ACTIVE_TEXT = 'SAFEWALK_BUTTON_ALARM_ACTIVE_TEXT'
export const SAFEWALK_BUTTON_BEGIN_TEXT = 'SAFEWALK_BUTTON_BEGIN_TEXT'
export const SAFEWALK_BUTTON_WALK_ACTIVE_TEXT = 'SAFEWALK_BUTTON_WALK_ACTIVE_TEXT'
export const SAFEWALK_BUTTON_WARNING_TEXT = 'SAFEWALK_BUTTON_WARNING_TEXT'
export const SAFEWALK_CONTACTS_DESCRIPTION = 'SAFEWALK_CONTACTS_DESCRIPTION'
export const SAFEWALK_CONTACTS_DISCLAIMER = 'SAFEWALK_CONTACTS_DISCLAIMER'
export const SAFEWALK_CONTACTS_FORM_DESCRIPTION = 'SAFEWALK_CONTACTS_FORM_DESCRIPTION'
export const SAFEWALK_CUSTOM_DURATION_TEXT = 'SAFEWALK_CUSTOM_DURATION_TEXT'
export const SAFEWALK_OFF_CAMPUS_CONTACTS_DESCRIPTION = 'SAFEWALK_OFF_CAMPUS_CONTACTS_DESCRIPTION'
export const SAFEWALK_OFF_CAMPUS_CONTACTS_FORM_DESCRIPTION = 'SAFEWALK_OFF_CAMPUS_CONTACTS_FORM_DESCRIPTION'
export const SAFEWALK_OFF_CAMPUS_INFO_ONE_TEXT = 'SAFEWALK_OFF_CAMPUS_INFO_ONE_TEXT'
export const SAFEWALK_OFF_CAMPUS_INFO_TWO_TEXT = 'SAFEWALK_OFF_CAMPUS_INFO_TWO_TEXT'
export const SAFEWALK_OFF_CAMPUS_TEXT = 'SAFEWALK_OFF_CAMPUS_TEXT'
export const SAFEWALK_ON_CAMPUS_TEXT = 'SAFEWALK_ON_CAMPUS_TEXT'
export const SAFEWALK_SMS_DESCRIPTION = 'SAFEWALK_SMS_DESCRIPTION'
export const SAFEWALK_TIMER_EXPIRY_INFO = 'SAFEWALK_TIMER_EXPIRY_INFO'
export const SAFEWALK_ON_CAMPUS_QUESTION_TEXT = 'SAFEWALK_ON_CAMPUS_QUESTION_TEXT'
export const SAFEWALK_INSTALL_BANNER_HEADER = 'SAFEWALK_INSTALL_BANNER_HEADER'
export const SAFEWALK_INSTALL_BANNER_BODY = 'SAFEWALK_INSTALL_BANNER_BODY'

export const COMMON_CONFIRM = 'COMMON_CONFIRM'
export const COMMON_DENY = 'COMMON_DENY'

export const BUTTON_CANCEL = 'BUTTON_CANCEL'
export const BUTTON_CLOSE = 'BUTTON_CLOSE'
export const BUTTON_CONTINUE = 'BUTTON_CONTINUE'
export const BUTTON_DIAL_911 = 'BUTTON_DIAL_911'
export const BUTTON_DIAL_911_SHORT = 'BUTTON_DIAL_911_SHORT'
export const BUTTON_DOWNLOAD = 'BUTTON_DOWNLOAD'
export const BUTTON_EMERGENCY = 'BUTTON_EMERGENCY'
export const BUTTON_MESSAGE_LOCATION = 'BUTTON_MESSAGE_LOCATION'
export const BUTTON_OK = 'BUTTON_OK'
export const BUTTON_OPEN_APP = 'BUTTON_OPEN_APP'
export const BUTTON_PANIC = 'BUTTON_PANIC'
export const BUTTON_SAFEWALK_ACTIVATE = 'BUTTON_SAFEWALK_ACTIVATE'
export const BUTTON_SAFEWALK_ADD_CONTACTS = 'BUTTON_SAFEWALK_ADD_CONTACTS'
export const BUTTON_SAFEWALK_CANCEL_ALARM = 'BUTTON_SAFEWALK_CANCEL_ALARM'
export const BUTTON_SAFEWALK_CHECK_IN_TIMER_SET = 'BUTTON_SAFEWALK_CHECK_IN_TIMER_SET'
export const BUTTON_SAFEWALK_CHECKIN_TIMER = 'BUTTON_SAFEWALK_CHECKIN_TIMER'
export const BUTTON_SAFEWALK_END_WALK = 'BUTTON_SAFEWALK_END_WALK'
export const BUTTON_SAFEWALK_NEW_WALK = 'BUTTON_SAFEWALK_NEW_WALK'
export const BUTTON_SAFEWALK_TRIGGER_ALARM = 'BUTTON_SAFEWALK_TRIGGER_ALARM'
export const BUTTON_SEND = 'BUTTON_SEND'
export const BUTTON_SUBMIT = 'BUTTON_SUBMIT'
export const BUTTON_SUBMIT_SILENT_ALERT = 'BUTTON_SUBMIT_SILENT_ALERT'
export const BUTTON_TIP_CATEGORY = 'BUTTON_TIP_CATEGORY'
export const BUTTON_TIP_LOCATION = 'BUTTON_TIP_LOCATION'

export const EMPTY_STATE_RESOURCES = 'EMPTY_STATE_RESOURCES'

export const ERROR_ACCOUNT_SETUP = 'ERROR_ACCOUNT_SETUP'
export const ERROR_CONFIG_UNDEFINED = 'ERROR_CONFIG_UNDEFINED'
export const ERROR_FIREBASE = 'ERROR_FIREBASE'
export const ERROR_TITLE = 'ERROR_TITLE'
export const ERROR_VALIDATION_401 = 'ERROR_VALIDATION_401'

export const INDICATOR_NEW_MESSAGES = 'INDICATOR_NEW_MESSAGES'
export const INDICATOR_SCROLL = 'INDICATOR_SCROLL'

export const INTRO_SCREEN_ONE_TITLE = 'INTRO_SCREEN_ONE_TITLE'
export const INTRO_SCREEN_ONE_DESCRIPTION = 'INTRO_SCREEN_ONE_DESCRIPTION'
export const INTRO_SCREEN_TWO_TITLE = 'INTRO_SCREEN_TWO_TITLE'
export const INTRO_SCREEN_TWO_DESCRIPTION = 'INTRO_SCREEN_TWO_DESCRIPTION'
export const INTRO_SCREEN_THREE_TITLE = 'INTRO_SCREEN_THREE_TITLE'
export const INTRO_SCREEN_THREE_DESCRIPTION = 'INTRO_SCREEN_THREE_DESCRIPTION'
export const INTRO_SCREEN_FOUR_TITLE = 'INTRO_SCREEN_FOUR_TITLE'
export const INTRO_SCREEN_FOUR_DESCRIPTION = 'INTRO_SCREEN_FOUR_DESCRIPTION'

export const LABEL_ACCOUNT = 'LABEL_ACCOUNT'
export const LABEL_TIP_CATEGORY = 'LABEL_TIP_CATEGORY'
export const LABEL_TIP_LOCATION = 'LABEL_TIP_LOCATION'
export const LABEL_TIP_PRIVATE = 'LABEL_TIP_PRIVATE'

export const LAUNCH = 'LAUNCH'
export const LAUNCH_SCENARIO = 'LAUNCH_SCENARIO'

export const MESSAGE_LOCATION = 'MESSAGE_LOCATION'
export const MESSAGE_LOCATION_ERROR_TOAST = 'MESSAGE_LOCATION_ERROR_TOAST'
export const MESSAGE_TITLE_TIP = 'MESSAGE_TITLE_TIP'
export const MESSAGE_TITLE_TIP_ANONYMOUS = 'MESSAGE_TITLE_TIP_ANONYMOUS'

export const MODAL_BODY_LOCATION_PERMISSION = 'MODAL_BODY_LOCATION_PERMISSION'
export const MODAL_BODY_LOCATION_PERMISSION_DENIED = 'MODAL_BODY_LOCATION_PERMISSION_DENIED'
export const MODAL_BODY_TIP_TITLE = 'MODAL_BODY_TIP_TITLE'
export const MODAL_BODY_TIP_TITLE_ANON = 'MODAL_BODY_TIP_TITLE_ANON'
export const MODAL_BODY_TIP_BODY = 'MODAL_BODY_TIP_BODY'
export const MODAL_BODY_TIP_EMERGENCY = 'MODAL_BODY_TIP_EMERGENCY'
export const MODAL_TITLE_LOCATION_PERMISSION = 'MODAL_TITLE_LOCATION_PERMISSION'
export const MODAL_TITLE_LOCATION_PERMISSION_DENIED = 'MODAL_TITLE_LOCATION_PERMISSION_DENIED'

export const NO_RESPONSE = 'NO_RESPONSE'
export const NOT_AUTH_TITLE = 'NOT_AUTH_TITLE'
export const NOT_AUTH_SUBTITLE = 'NOT_AUTH_SUBTITLE'
export const NOT_FOUND_TITLE = 'NOT_FOUND_TITLE'
export const NOT_FOUND_SUBTITLE = 'NOT_FOUND_SUBTITLE'

export const PLACEHOLDER_MESSAGE = 'PLACEHOLDER_MESSAGE'
export const PLACEHOLDER_RESPONSE = 'PLACEHOLDER_RESPONSE'
export const PLACEHOLDER_RESOURCES_FILTER = 'PLACEHOLDER_RESOURCES_FILTER'
export const PLACEHOLDER_TIP = 'PLACEHOLDER_TIP'

export const PRIORITY_HEADER_GUN = 'PRIORITY_HEADER_GUN'
export const PRIORITY_HEADER_PANIC = 'PRIORITY_HEADER_PANIC'
export const PRIORITY_HEADER_TIP = 'PRIORITY_HEADER_TIP'
export const PRIORITY_FALSE_POSITIVE = 'PRIORITY_MENU_FALSE_POSITIVE'
export const PRIORITY_MENU_RESOLVE = 'PRIORITY_MENU_RESOLVE'
export const PRIORITY_BADGE_RESOLVED = 'PRIORITY_MENU_RESOLVED'

export const PUSH_REG_TEXT = 'PUSH_REG_TEXT'

export const SCREEN_TITLE_TIP = 'SCREEN_TITLE_TIP'
export const SCREEN_TITLE_TIP_ATTACHMENT = 'SCREEN_TITLE_TIP_ATTACHMENT'
export const SCREEN_TITLE_TIP_CATEGORY = 'SCREEN_TITLE_TIP_CATEGORY'
export const SCREEN_TITLE_TIP_LOCATION = 'SCREEN_TITLE_TIP_LOCATION'
export const SECTION_TITLE_ACCOUNT = 'SECTION_TITLE_ACCOUNT'
export const SECTION_TITLE_DISPLAY = 'SECTION_TITLE_DISPLAY'

export const TAB_TITLE_MESSAGES = 'TAB_TITLE_MESSAGES'
export const TAB_TITLE_RESOURCES = 'TAB_TITLE_RESOURCES'
export const TAB_TITLE_SAFEWALK = 'TAB_TITLE_SAFEWALK'
export const TAB_TITLE_TIPS = 'TAB_TITLE_TIPS'

export const TIP_CATEGORY_DEFAULT = 'TIP_CATEGORY_DEFAULT'
export const TIP_LOCATION_ERROR_TOAST = 'TIP_LOCATION_ERROR_TOAST'
export const TIP_SCREEN_EMERGENCY_LINE_ONE = 'TIP_SCREEN_EMERGENCY_LINE_ONE'
export const TIP_SCREEN_EMERGENCY_LINE_TWO = 'TIP_SCREEN_EMERGENCY_LINE_TWO'

export const USER = 'USER'
export const USERS = 'USERS'

export const USER_ERROR_DEFAULT = 'USER_ERROR_DEFAULT'
export const USER_ERROR_MAX_UPLOADS = 'USER_ERROR_MAX_UPLOADS'
export const USER_ERROR_1001 = 'USER_ERROR_1001'
export const USER_ERROR_1002 = 'USER_ERROR_1002'
export const USER_ERROR_2001 = 'USER_ERROR_2001'
export const USER_ERROR_3001 = 'USER_ERROR_3001'
export const USER_ERROR_3002 = 'USER_ERROR_3002'
export const USER_ERROR_4001 = 'USER_ERROR_4001'
export const USER_ERROR_4002 = 'USER_ERROR_4002'
export const USER_ERROR_4003 = 'USER_ERROR_4003'
export const USER_ERROR_4004 = 'USER_ERROR_4004'
export const USER_ERROR_4005 = 'USER_ERROR_4005'
export const USER_ERROR_4006 = 'USER_ERROR_4006'
export const USER_ERROR_5001 = 'USER_ERROR_5001'
